const defaultOptions = {
    navigation: {
        prevEl: '.js-slider-teaser-prev',
        nextEl: '.js-slider-teaser-next',
        disabledClass: 'hidden',
    },
    spaceBetween: 20,
    slidesPerView: 1,
    watchSlidesVisibility: true,
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    },
};

const sliderTeaser = {
    init() {
        const elements = document.querySelectorAll('.js-slider-teaser');

        if (!elements.length) return;

        elements.forEach((element) => {
            const Slider = slider.default;
            const newOptions = defaultOptions;

            const {slidesperview, autoplay, loop} = element.dataset;
            if (parseInt(slidesperview, 10) > 0) {
                newOptions.breakpoints = {};
                newOptions.slidesPerView = slidesperview;
            }

            if (autoplay === '1') {
                newOptions.autoplay = true;
            }

            if (loop === '1') {
                newOptions.loop = true;
            }

            this.sliderTeaser = new Slider(element, newOptions);
        });
    },
};

export default sliderTeaser;
